import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { ImSearch } from "react-icons/im";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip, Button, Modal, Form } from "react-bootstrap";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useHasPermission } from "hooks/useHasPermission";
import CrossIcon from '../../../assets/img/file-cut-icon.png';
import { toast, ToastContainer } from 'react-toastify';
import api from '../../../services/api';
import { fetchExistingEmployeeList } from "../../../redux/slice/getExistingEmpListSlice";
import updateEmployeeRole from "../../../redux/slice/updateEmployeeRoleSlice"
import EditRoleModal from "../../../components/common/EditRoleModal";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { fetchSearchData } from "../../../redux/slice/searchDataSlice";
import axiosPrivate from "services/axios/axiosPrivate";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { resendWelcomeMail } from "../../../redux/slice/resendWelcomeMailSlice"
import EditEmpAccountStatusModal from "../employee/EditEmpAccountStatusModal";
import { empAccountStatus, resetEmpAccStatus } from "../../../redux/slice/empAccountStatusSlice";
import { ConfirmAccStatusModal } from "../employee/ConfirmAccStatusModal";
import { deleteExistingEmp } from "../../../redux/slice/deleteExistingEmpSlice"
import { approveExistingEmp } from "../../../redux/slice/approveExistingEmpSlice"
export default function ExistingEmpTable() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useSelector(state => console.log('state.existingEmployees', state));
    const { existingEmployees, status } = useSelector(state => state.existingEmployees);
    const searchDataList = useSelector(
        (state) => state.SearchData.SearchDataList
    );

    const [totalItems, setTotalItems] = useState(existingEmployees?.totalItems ?? 0);
    const [totalPages, setTotalPages] = useState(existingEmployees?.totalPages ?? 1);
    const [currentPage, setCurrentPage] = useState(1);
    const [statusCount, setStatusCount] = useState(existingEmployees?.statusCount ?? []);
    const [selectedEmpForAccStatus, setSelectedEmpForAccStatus] = useState(null);
    const [showConfirmAccStatusModal, setShowConfirmAccStatusModal] = useState(false);
    const [pendingEmpAccStatus, setPendingEmpAccStatus] = useState('');
    const [showAccountStatusModal, setShowAccountStatusModal] = useState(false);
    const [showDeleteEmpModal, setShowDeleteEmpModal] = useState(false);
    const [showApproveEmpModal, setShowApproveEmpModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingList, setEditingList] = useState(null);
    const [firstName, setFirstName] = useState("")
    const [middleName, setMiddleName] = useState("")
    const [lastName, setLastName] = useState("")
    const [emailId, setEmailId] = useState("")
    const [mobileNo, setMobileNo] = useState("")
    const [role, setRole] = useState("")
    const [restEmployees, setRestEmployees] = useState([]);
    const [displayedEmployees, setDisplayedEmployees] = useState(restEmployees);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState("firstName");
    const [direction, setDirection] = useState('asc');
    const [showEditRoleModal, setShowEditRoleModal] = useState(false);
    const [empEditRole, setEmpEditRole] = useState({});
    const [deleteEmpId, setDeleteEmpId] = useState(null);
    const [approveEmpList, setApproveEmpList] = useState([]);

    const canViewEmployee = useHasPermission("Employee-view");
    const canEditEmployee = useHasPermission("Employee-manage");
    const canViewEmployeeDetails = useHasPermission("Employee Details-view");
    const canViewExport = useHasPermission("Export Employee Data-view");
    const canEditExport = useHasPermission("Export Employee Data-manage");

    useEffect(() => {
        setTotalItems(searchDataList?.totalItems)
        setTotalPages(searchDataList?.totalPages)
        // FIX: If backend sends page 0, we store it as 1 for our UI logic
        const backendPage = searchDataList?.pageNo ?? 0;
        setCurrentPage(backendPage === 0 ? 1 : backendPage + 1);
        setStatusCount(searchDataList?.statusCount)
        setRestEmployees(searchDataList?.result);
        setDisplayedEmployees(searchDataList?.result);
    }, [searchDataList]);

    useEffect(() => {
        if (canViewEmployee && currentPage === 1) {
            dispatch(fetchExistingEmployeeList({ page: 1, SB: sortBy, order: direction }));
        }
    }, [dispatch, canViewEmployee]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setTotalItems(existingEmployees?.totalItems)
            setTotalPages(existingEmployees?.totalPages)
            setCurrentPage((existingEmployees?.currentPage + 1))
            setStatusCount(existingEmployees?.statusCount)
            setRestEmployees(existingEmployees?.content);
            setDisplayedEmployees(existingEmployees?.content);
        }
    }, [existingEmployees, totalPages, totalItems, currentPage, statusCount, searchTerm]);

    useEffect(() => {
        if (!searchTerm || searchTerm.trim().length < 1) {
            return;
        }

        const timerId = setTimeout(() => {
            dispatch(fetchSearchData({ type: "employee", keyword: searchTerm.trim(), page: 0 }));
        }, 1000);
        return () => {
            clearTimeout(timerId);
        };
    }, [searchTerm, dispatch]);

    if (!canViewEmployee) {
        return <p className="perm-msg">You don’t have permission to view employee page!</p>;
    };

    const restEmployee = restEmployees?.slice(1)?.filter(c => c !== null);
    const filteredEmployeeData = restEmployee?.filter(user => user.joinedStatus === true);

    const formatLabel = (value) => {
        if (!value) return "";
        return value
            // permanentEmployees -> permanent Employees
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            // INFORMATION_TECHNOLOGY -> INFORMATION TECHNOLOGY
            .replace(/_/g, " ")
            // sabko lowercase karo
            .toLowerCase()
            // har word ka first letter capital
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const handleUpdateList = async (event) => {
        if (!canEditEmployee) {
            toast.error("You don't have permission to edit Employee details", { className: 'toast-error-custom', autoClose: 5000 });
            return;
        }
        event.preventDefault();
        if (!editingList) return;

        try {
            const url = `${api.updateInviteCandidate}`;

            const updatedData = { 'firstName': firstName, 'middleName': middleName, 'lastName': lastName, 'roleName': role, 'email': emailId, 'mobile': mobileNo };
            const response = await axiosPrivate.post(url, updatedData);
            if (response.status === 200) {
                toast.success("Details updated successfully", { className: 'toast-success-custom' });
                setShowEditModal(false);
                setEditingList(null);
            }
        } catch (error) {
            toast.error(error?.message || "Server error during update", { className: 'toast-error-custom' });
        }

    }
    const handleViewDetailsClick = (id, empType) => {
        if (!canViewEmployeeDetails) {
            toast.error("You don't have permission to view employee details", { className: 'toast-error-custom', autoClose: 5000 });
            return;
        }
        navigate(`/admin/employee/details/${id}`, { state: { empType } });
    };

    const renderTooltip = (props, description) => (
        <Tooltip id="button-tooltip" {...props}>
            {description}
        </Tooltip>
    );

    const handleExport = () => {
        if (!canEditExport) {
            toast.error("You don't have permission to export data", { className: 'toast-error-custom', autoClose: 5000 });
            return;
        }
        const exportData = filteredEmployeeData.map(user => ({
            'Name': user.fullName,
            'Role': user.roleName,
            'Email ID': user.email,
            'Mob. No.': user.mobile ?? '-',
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Employees");

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        saveAs(data, 'Employees_report.xlsx');
    };
    const handlePageChange = (_, value) => {
        if (canViewEmployee) {

            if (searchTerm.trim() === '') {
                dispatch(fetchExistingEmployeeList({ page: value, SB: sortBy, order: direction }));
            }
            else {
                // Add Math.max(0, ...) to prevent negative page numbers
                const targetPage = Math.max(0, value - 1);
                dispatch(fetchSearchData({ type: "employee", keyword: searchTerm.trim(), page: targetPage }));
            }
        }
    };

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleInitialConfirmAccStatus = (selectedStatus) => {
        setPendingEmpAccStatus(selectedStatus);
        setShowAccountStatusModal(false);
        setShowConfirmAccStatusModal(true);
    };

    const handleEmpAccountStatusConfirm = (selectedStatusValue) => {
        if (!selectedEmpForAccStatus) return;

        dispatch(empAccountStatus({
            userId: selectedEmpForAccStatus.userId,
            status: selectedStatusValue
        })).then((result) => {
            // Only refresh list if the API call was successful
            if (result.meta.requestStatus === 'fulfilled') {
                if (searchTerm.trim() === '') {
                    dispatch(fetchExistingEmployeeList({ page: currentPage, SB: sortBy, order: direction }));
                } else {
                    dispatch(fetchSearchData({ type: "employee", keyword: searchTerm.trim(), page: currentPage }));
                }
                setShowConfirmAccStatusModal(false);
                setSelectedEmpForAccStatus(null);
            }
        });
    };

    const handleFullCleanup = () => {
        setShowAccountStatusModal(false);
        setShowConfirmAccStatusModal(false);
        setSelectedEmpForAccStatus(null);
        if (resetEmpAccStatus) {
            dispatch(resetEmpAccStatus());
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (searchTerm.trim()) {
            dispatch(fetchSearchData({ type: "employee", keyword: searchTerm.trim(), page: 0 }));
        }
    };

    const handleSortBy = (event) => {
        const selectedFilter = event.target.value;

        switch (selectedFilter) {
            case "Name":
                setSortBy("firstName");
                dispatch(fetchExistingEmployeeList({ page: 1, SB: "firstName", order: direction }));
                break;
            // case "Role":
            //   setSortBy("roleName");
            //   dispatch(fetchEmployeeList({page:1,SB:"roleName",order:direction}));
            //   break;
            case "Email Id":
                setSortBy("email");
                dispatch(fetchExistingEmployeeList({ page: 1, SB: "email", order: direction }));
                break;

            case "Mobile No.":
                setSortBy("mobile");
                dispatch(fetchExistingEmployeeList({ page: 1, SB: "mobile", order: direction }));
                break;

            default:
                break;
        }

        setDisplayedEmployees(existingEmployees?.content);
    };

    const handleOrderBy = (event) => {
        const selectedFilter = event.target.value;

        switch (selectedFilter) {
            case "Ascending":
                setDirection("asc");
                dispatch(fetchExistingEmployeeList({ page: 1, SB: sortBy, order: "asc" }));
                break;

            case "Descending":
                setDirection("desc");
                dispatch(fetchExistingEmployeeList({ page: 1, SB: sortBy, order: "desc" }));
                break;

            default:
                break;
        }

        setDisplayedEmployees(existingEmployees?.content);
    };

    const handleDeleteEmp = async () => {
        // if (!canEditEmployee) {
        //   toast.error("You don't have permission to resend welcome mail", {
        //     className: "toast-error-custom",
        //     autoClose: 5000,
        //   });
        //   return;
        // }
        console.log('deleteEmpId', deleteEmpId)
        if (approveEmpList) {
            await dispatch(deleteExistingEmp(deleteEmpId));
        }
        dispatch(fetchExistingEmployeeList({ page: 1, SB: sortBy, order: direction }));
        setShowDeleteEmpModal(false);
        setDeleteEmpId(null);
    };
    const handleApproveEmp = async () => {
        // if (!canEditEmployee) {
        //   toast.error("You don't have permission to resend welcome mail", {
        //     className: "toast-error-custom",
        //     autoClose: 5000,
        //   });
        //   return;
        // }
        // console.log('approveExistingEmp',approveExistingEmp)
        const payload = {
            "userId": approveEmpList
        }
        if (approveEmpList) {
            await dispatch(approveExistingEmp(payload));
        }
        dispatch(fetchExistingEmployeeList({ page: 1, SB: sortBy, order: direction }));
        setShowApproveEmpModal(false);
        setApproveEmpList([]);
    };

    const handleCheckboxChange = (userId, isChecked) => {
        if (isChecked) {
            setApproveEmpList((prev) => [...prev, userId]);
        } else {
            setApproveEmpList((prev) => prev.filter((id) => id !== userId));
        }
        console.log('setApproveEmpList', approveEmpList)
    };

    return (
        <div className="container-fluid" style={{ marginBottom: "30px" }}>
            <Breadcrumb />
            {/* employee list page */}
            <div className="section-body">
                <div className="container-fluid">
                    <div className="tab-content">
                        <div className="tab-pane fade active show" id="Employee-list" role="tabpanel" >
                            <div className="card">
                                <div className="card-header">
                                    <div className="employeelist-header">
                                        <div>
                                            <button className="primary-btn mt-0 pl-4 pr-4" title="approve" onClick={() => { setShowApproveEmpModal(true) }}>
                                                Approve
                                            </button>
                                        </div>

                                        <div className="d-flex align-items-center"
                                            style={{ gap: "10px" }}>
                                            <div>
                                                <h3 className="card-title mb-0 ml-4 ">Sort By :</h3>
                                            </div>
                                            <div>
                                                <form>
                                                    <div className="d-flex align-items-center ">
                                                        <select
                                                            className="custom-select"
                                                            onChange={handleOrderBy}
                                                        >
                                                            <option>Ascending</option>
                                                            <option>Descending </option>
                                                        </select>
                                                    </div>
                                                </form>
                                            </div>
                                            <div>
                                                <form>
                                                    <div className="d-flex align-items-center">
                                                        <select
                                                            className="custom-select"
                                                            onChange={handleSortBy}
                                                        >
                                                            <option>Name</option>
                                                            {/* <option>Role</option> */}
                                                            <option>Email Id</option>
                                                            <option>Mobile No.</option>
                                                        </select>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        {/* <div>
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={(props) =>
                                                    renderTooltip(
                                                        props,
                                                        "Search by employee name or mob no."
                                                    )
                                                }
                                            >
                                                <form className="user-searchForm">
                                                    <input
                                                        className="form-control me-2 search"
                                                        type="search"
                                                        placeholder="Search employee"
                                                        aria-label="Search"
                                                        value={searchTerm}
                                                        onChange={handleInputChange}
                                                    />
                                                    <button type="submit" className="btn-interactive" onClick={handleFormSubmit} aria-label="Submit Search">
                                                        <ImSearch className="searchIcon" />
                                                    </button>
                                                </form>
                                            </OverlayTrigger>
                                        </div> */}
                                    </div>
                                    {/* <button className="primary-btn mt-0 pl-4 pr-4" title={
                      canViewExport
                        ? "export data"
                        : "No permission to export data"
                    }
                      disabled={!canViewExport}
                      onClick={
                        canEditExport
                          ? handleExport
                          : undefined
                      }>
                      Export
                    </button> */}
                                    <div className="card-body">
                                        {status === 'loading' && (
                                            <p className="loading">Loading...</p>
                                        )}

                                        {status === 'failed' && (
                                            <p className="server-error-msg">Unable to connect to server</p>
                                        )}
                                        {status == "succeeded" && (

                                            <div className="user-table">
                                                <table
                                                    className="table table-hover table-vcenter text-nowrap mb-0"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th className="name-column" style={{ width: "55px", textAlign: "center" }}></th>
                                                            <th style={{ width: "90px" }}>Emp. ID</th>
                                                            <th>Name</th>

                                                            <th>Email ID</th>
                                                            {/* <th>Personal Email</th> */}
                                                            <th style={{ width: "115px", textAlign: "center" }}>Mobile. No.</th>
                                                            <th style={{ width: "170px" }}>Role</th>
                                                            <th style={{ width: "90px" }}>Status</th>
                                                            <th
                                                                ref={(el) => {
                                                                    if (el) {
                                                                        el.style.setProperty("padding", "5px", "important");
                                                                        el.style.setProperty("width", "65px");
                                                                        el.style.setProperty("text-align", "center");
                                                                    }
                                                                }}
                                                            >Action</th>
                                                        </tr>
                                                    </thead>
                                                    {displayedEmployees?.length === 0 ? (
                                                        <p className="no-record-msg server-error-msg">-- No record found for existing employees -- </p>
                                                    ) : (
                                                        <tbody>
                                                            {displayedEmployees?.map((list, index) => {
                                                                console.log("list:", list);
                                                                const menuActions = [
                                                                    {
                                                                        label: "View",
                                                                        icon: require("assets/img/view-icon.png"),
                                                                        title: canViewEmployeeDetails ? "view" : "No permisssion to view employee",
                                                                        permission: canViewEmployeeDetails,
                                                                        onClick: () => {
                                                                            handleViewDetailsClick(list?.userId, list?.documentUploadStatus);
                                                                            setShowEditRoleModal(true)
                                                                        },
                                                                        show: true,

                                                                    },

                                                                    {
                                                                        label: "Delete Employee",
                                                                        icon: require("assets/img/user-icon.png"),
                                                                        title: "Delete Employee",
                                                                        permission: true,
                                                                        iconStyle: { width: '20px', height: '20px' },
                                                                        onClick: () => { setDeleteEmpId(list.userId); setShowDeleteEmpModal(true) },
                                                                        show: true,
                                                                    },
                                                                ];
                                                                return (
                                                                    <tr key={list.id} role="gridcell"
                                                                        onClick={
                                                                            canViewEmployeeDetails
                                                                                ? () => handleViewDetailsClick(list?.userId)
                                                                                : undefined
                                                                        } style={{ cursor: canViewEmployeeDetails ? 'pointer' : 'default' }}>
                                                                        <td>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="check"
                                                                                checked={approveEmpList?.includes(list.userId)}
                                                                                onChange={(e) => handleCheckboxChange(list.userId, e.target.checked)}
                                                                            />
                                                                        </td>
                                                                        <td>{list?.employeeId ?? "-"}</td>
                                                                        <td role="gridcell"
                                                                            onClick={
                                                                                canViewEmployeeDetails
                                                                                    ? () => handleViewDetailsClick(list?.userId)
                                                                                    : undefined
                                                                            } style={{ cursor: canViewEmployeeDetails ? 'pointer' : 'default' }}>{list?.fullName ?? "-"}
                                                                        </td>

                                                                        <td>
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={
                                                                                    <Tooltip id={`email-tooltip-${list.userId}`}>
                                                                                        {list?.email ?? "-"}
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <span style={{ cursor: 'pointer' }}>
                                                                                    {list?.email ?? "-"}
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        {/* <td>{list?.personalEmail ?? "-"}</td> */}
                                                                        <td>{list?.mobile ?? "-"}</td>
                                                                        <td>{formatLabel(list?.roleName ?? "-")}</td>
                                                                        <td>{formatLabel(list?.accountStatus ?? "-")}</td>
                                                                        <td className="action-column">
                                                                            <PopupState
                                                                                variant="popover"
                                                                                popupId="demo-popup-menu"
                                                                            >
                                                                                {(popupState) => (
                                                                                    <>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-icon btn-sm icons"
                                                                                            {...bindTrigger(popupState)}
                                                                                        >
                                                                                            <img
                                                                                                src={require("assets/img/more.png")}
                                                                                                alt="more"
                                                                                                className="action-icon"
                                                                                                style={{
                                                                                                    opacity: canViewEmployeeDetails
                                                                                                        ? 1
                                                                                                        : 0.5,
                                                                                                }}
                                                                                            />
                                                                                        </button>

                                                                                        <Menu {...bindMenu(popupState)}>
                                                                                            {menuActions
                                                                                                .filter(
                                                                                                    (action) => action.show,
                                                                                                )
                                                                                                .map((action, index) => (
                                                                                                    <MenuItem
                                                                                                        key={index}
                                                                                                        disabled={
                                                                                                            !action.permission
                                                                                                        }
                                                                                                        onClick={() => {
                                                                                                            popupState.close();
                                                                                                            if (action.permission)
                                                                                                                action.onClick();
                                                                                                        }}
                                                                                                    >
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-icon btn-sm icons me-2"
                                                                                                            title={
                                                                                                                action.permission
                                                                                                                    ? action.label
                                                                                                                    : "No permission"
                                                                                                            }
                                                                                                            disabled={
                                                                                                                !action.permission
                                                                                                            }
                                                                                                        >
                                                                                                            <img
                                                                                                                src={action.icon}
                                                                                                                alt={action.label}
                                                                                                                className="action-icon"
                                                                                                                style={{
                                                                                                                    opacity:
                                                                                                                        action.permission
                                                                                                                            ? 1
                                                                                                                            : 0.5,
                                                                                                                    ...action.iconStyle
                                                                                                                }}
                                                                                                            />
                                                                                                        </button>
                                                                                                        {action.label}
                                                                                                    </MenuItem>
                                                                                                ))}
                                                                                        </Menu>
                                                                                    </>
                                                                                )}
                                                                            </PopupState>
                                                                        </td>
                                                                        {/* <td>
                                      <button type="button" className="btn btn-icon btn-sm icons" title={
                                        canViewEmployeeDetails
                                          ? "view"
                                          : "No permission to see employee details"
                                      }
                                        disabled={!canViewEmployeeDetails}
                                        onClick={
                                          canViewEmployeeDetails
                                            ? () => handleViewDetailsClick(list?.userId)
                                            : undefined
                                        }>
                                        <img src={require("assets/img/view-icon.png")} alt="view" className='action-icon' style={{
                                          opacity: canViewEmployeeDetails ? 1 : 0.5
                                        }} />
                                      </button>
                                    </td> */}
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    )
                                                    }
                                                </table>
                                                {displayedEmployees?.length > 0 ? (
                                                    <Stack spacing={2} sx={{ marginTop: 3, alignItems: 'center' }}>
                                                        <Pagination
                                                            count={totalPages}
                                                            page={currentPage}
                                                            onChange={handlePageChange}
                                                            shape="rounded"
                                                            color="primary"
                                                            disabled={status === 'loading'}
                                                        />
                                                    </Stack>
                                                ) : null}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditRoleModal
                show={showEditRoleModal}
                onHide={() => setShowEditRoleModal(false)}
                setShowEditRoleModal={setShowEditRoleModal}
                employeeData={empEditRole}
                onUpdate={updateEmployeeRole}
            />
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header>
                    <Modal.Title>Edit List</Modal.Title>
                    <button
                        onClick={() => setShowEditModal(false)}
                        className="modal-close">
                        <img src={CrossIcon} alt="Close" style={{ width: '20px', height: '20px' }} />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleUpdateList}>
                        <Form.Group className="mb-3">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Middle Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={middleName}
                                onChange={(e) => setMiddleName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Role</Form.Label>
                            <Form.Control
                                type="text"
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email Id</Form.Label>
                            <Form.Control
                                type="email"
                                value={emailId}
                                onChange={(e) => setEmailId(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Mobile No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="cancel-cta" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button variant="update-cta" onClick={canEditEmployee ? handleUpdateList : undefined} disabled={!canEditEmployee}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>
            <EditEmpAccountStatusModal
                show={showAccountStatusModal}
                onHide={handleFullCleanup}
                currentStatus={selectedEmpForAccStatus?.accountStatus === "ACTIVE" ? 'active' : 'inactive'}
                onConfirm={handleInitialConfirmAccStatus}
            />
            <ConfirmAccStatusModal
                show={showConfirmAccStatusModal}
                onHide={handleFullCleanup}
                onConfirm={() => handleEmpAccountStatusConfirm(pendingEmpAccStatus)}
                title="Confirm Account Status"
                message={
                    <>
                        Are you sure you want to change the status of <strong>{selectedEmpForAccStatus?.fullName}</strong> to <strong>{pendingEmpAccStatus}</strong>?
                    </>
                }
            />
            <Modal
                show={showDeleteEmpModal}
                onHide={() => setShowDeleteEmpModal(false)}

            >
                <Modal.Header>
                    <Modal.Title className="d-flex align-items-center mb-0">
                        Confirm Delete Employee
                    </Modal.Title>
                    <button
                        onClick={() => setShowDeleteEmpModal(false)}
                        className="modal-close"
                        aria-label="Close"
                    >
                        <img
                            src={CrossIcon}
                            alt="Close"
                            style={{ width: "20px", height: "20px" }}
                        />
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <p className="mb-0">
                        Are you sure you want to delete this employee?
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="cancel-cta"
                        onClick={() => setShowDeleteEmpModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button variant="update-cta" onClick={handleDeleteEmp}>
                        Yes, Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showApproveEmpModal}
                onHide={() => setShowApproveEmpModal(false)}
            >
                <Modal.Header>
                    <Modal.Title className="d-flex align-items-center mb-0">
                        Confirm Approve Employee
                    </Modal.Title>
                    <button
                        onClick={() => setShowApproveEmpModal(false)}
                        className="modal-close"
                        aria-label="Close"
                    >
                        <img
                            src={CrossIcon}
                            alt="Close"
                            style={{ width: "20px", height: "20px" }}
                        />
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <p className="mb-0">
                        Are you sure you want to Approved these employees?
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="cancel-cta"
                        onClick={() => setShowApproveEmpModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button variant="update-cta" onClick={handleApproveEmp}>
                        Yes, Approve
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer />
        </div>
    );
}
